import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service'
import {toast} from 'react-toastify'
import Loading from "../../../../common/Loading";

const TimeZoneCard = () => {
    const {clinicId} = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [timeZone, setTimeZone] = useState(null);
    const [timeZoneList, setTimeZoneList] = useState([]);

    // Initialize form with empty default values
    const {register, handleSubmit, reset} = useForm();

    useEffect(() => {
        setIsLoading(true);
        clinicService.getTimeZone(clinicId)
            .then(res => {
                setTimeZone(res.data);
                // Reset form with the fetched timezone
                reset({ timezoneid: res.data.id });
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                toast.error("Error while getting Timezone", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });

        clinicService.getAllTimeZones()
            .then(res => {
                setTimeZoneList(res.data);
            })
            .catch(err => {
                toast.error("Error while getting All Timezone", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            });
    }, [clinicId, reset]); // Add reset to dependency array


    const onSubmit = (data) => {

        clinicService.updateTimezone(clinicId, data)
            .then(res => {

                toast.success("Updated Timezone", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
                setIsEditing(false);
                setTimeZone(res.data);
            })
            .catch(error => {
                toast.error("Error WHile Updating ", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })

            })
    }
    return (
        <>
            <div className="card card-padding shadow-none card-border">
                <div className="card-title">
                    <div className="d-flex justify-content-between align-items-center editClinic">
                        <div><i className="bi bi-globe"></i> Timezone</div>
                        <button
                            className={`btn btn-sm mt-2 ${isEditing ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                            onClick={() => setIsEditing(!isEditing)}
                        >
                            <i className={`bi ${isEditing ? 'bi-x' : 'bi-pencil-square'}`}></i>
                            {isEditing ? ' Cancel' : ' Edit'}
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    {isLoading ? <Loading /> :
                        isEditing ? <div>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-group">
                                        <select
                                            className="form-select"
                                            {...register("timezoneid")}
                                        >
                                            {timeZoneList.map(item => (
                                                <option
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.timezoneName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-4 pt-2 border-top">
                                        <button className="btn btn-success btn-sm mt-2" type="submit"><i
                                            className="bi bi-floppy"></i> Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                            :
                            <div>{timeZone && timeZone.timezoneName}</div>
                    }
                </div>
            </div>
        </>
    );
}

export default TimeZoneCard;